
import { StatusPageService } from './status-page.service';
import IncidentListComponent from './incident-list.component';

const moduleName = "statusPage";

angular.module(moduleName, [])
  // .provider('$statusPageServiceProvider', StatusPageServiceProvider)
  .service("StatusPageService", StatusPageService)
  .component('incidentList', IncidentListComponent);

export default {
  moduleName,
};

/**
 * @typedef {object} IStatusPageService
 * @property {() => angular.IPromise<any>} getIncidents
 */